import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";

/**
 * 基于axios封装请求类
 * @date:2019-7-9
 * @author:zwr
 */
import axios from 'axios';
import config from '@/config/index';
import { getToken, getSessionToken } from '@/utils/auth';
import { Message } from 'element-ui';
import router from "../router/index";
import qs from 'qs';
var defaultConfig = {
  baseURL: config.baseUrl,
  withCredentials: true,
  // 跨域是否携带第三方cookie
  timeout: 20 * 1000 // 超时时间

};
var contentType = {
  form: 'application/x-www-form-urlencoded;charset=utf-8',
  file: 'application/x-www-form-data;charset=utf-8'
};

function getService(config) {
  var servi = axios.create(config); // 重新封装get请求

  servi.newGet = servi.get;

  servi.get = function (url, data) {
    return servi.newGet(url, {
      params: data
    });
  }; // 增加导出的请求


  servi.export = function (url, data) {
    var iframe = document.getElementById('exportIframe');

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.id = 'exportIframe';
    }

    iframe.src = servi.defaults.baseURL + url + '?' + qs.stringify(data);
    document.documentElement.appendChild(iframe);
  }; // request interceptor


  servi.interceptors.request.use(function (conf) {
    // 默认向 header 中添加 token 字段
    var token = getToken(); // let token = getSessionToken();

    if (token) {
      conf.headers['Authorization-YT'] = 'Bearer ' + token;
    }

    if (conf.headers) {
      conf.headers.token = token;
    } else {
      conf.headers = {
        token: token
      };
    } // 判断 POST 请求 formData 数据提交


    if (conf.method === 'post' && conf.headers['Content-Type'] === contentType.form) {
      conf.data = qs.stringify(conf.data);
    }

    return conf;
  }, function (error) {
    return Promise.reject(error);
  }); // response interceptor

  servi.interceptors.response.use(function (response) {
    if (response.config.responseType == 'blob') {
      // return response;
      if (response.data.size) {
        var fileName = response.headers['content-disposition'] ? response.headers['content-disposition'].split('=')[1] : '';
        var url = URL.createObjectURL(new Blob([response.data], {
          type: response.data.type
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        var name = decodeURIComponent(fileName);
        link.setAttribute('download', name.replace(new RegExp(' ', 'g'), ''));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素

        window.URL.revokeObjectURL(url); //释放blob对象

        return Promise.resolve({
          msg: '导出成功！'
        });
      } else {
        return Promise.resolve({
          msg: '导出失败！'
        });
      }
    }

    var res = response.data; // if the custom code is not 20000, it is judged as an error.

    if (res.code == 200) {
      return res.data ? res.data : res;
    } else {
      if (res.code == 201) {
        sessionStorage.clear();
        localStorage.clear();
        router.push({
          path: '/login'
        });
      } else {
        var flag = router.currentRoute.path.indexOf('/login') > -1 || response.config.url.indexOf('/login') > -1 || response.config.url.indexOf('/captcha') > -1 || response.config.url.indexOf('/checkClassNum') > -1;

        if (!flag) {
          Message.error({
            message: res.message || 'Error',
            offset: 80,
            duration: 3 * 1000
          });
        }

        return Promise.reject(res);
      }
    }
  }, function (error) {
    if (error.message.includes('timeout')) {
      return Promise.reject({
        code: 504,
        message: '请求服务超时！'
      });
    } else {
      return Promise.reject(error);
    }
  });
  return servi;
} // create an axios instance


var service = getService(defaultConfig);
/*
 *   获取 CONTENT-TYPE:X-WWW-FORM-URLENCODED  的service
 */

var formService = getNewService({
  headers: {
    'Content-Type': contentType.form
  }
});
var fileService = getNewService({
  headers: {
    'Content-Type': contentType.file
  }
});
/*
 *   获取新的封装请求类
 */

function getNewService(param) {
  return getService(Object.assign({}, defaultConfig, param));
}

export { service, formService, fileService };